export const FEED_MODULE_KEY = 'feed';
export const FEED_BASE_ROUTE = '/feed';
export const FEED_FILTER_KEY = 'feed';
